import { IDable } from "./IDable";


export class Cache<T extends IDable>
{
    public Items: T[] = [];

    public Clear()
    {
        this.Items = [];
    }

    public Remove(item: T): void
    {
        const itemIndex = this.Items.indexOf(item);

        if (itemIndex == -1)
            return;

        this.Items.splice(itemIndex, 1);
    }

    public GetIndexById(id: string): number
    {
        return this.Items.findIndex(x => x.Id == id);
    }

    public UpdateOrAddSingle(item: T): void
    {
        const index = this.GetIndexById(item.Id);
        
        if (index)
            this.Items[index] = item;
        else
            this.Items.push(item);
    }

    public FindOne(id: string): T | null
    {
        return this.Items.find(x => x.Id == id) || null;
    }

    public UpdateOrAdd(...items: T[]): void
    {
        items.forEach(x => this.UpdateOrAddSingle(x));
    }
}
